import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:px-4" }
const _hoisted_2 = { class: "flex flex-wrap p-1 items-center gap-4 w-full" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex-1 flex flex-col" }
const _hoisted_5 = { class: "text-start text-sm font-medium" }

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupPromotionNavbar = _resolveComponent("PopupPromotionNavbar")
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")
  const _component_OrderList = _resolveComponent("OrderList")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupPromotionNavbar),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-xl text-amber-100 text-start font-extrabold my-3" }, "ตั้งค่าโปรโมชั่นอัตโนมัติ", -1 /* HOISTED */)),
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_OrderList, {
          modelValue: _ctx.promotions,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.promotions) = $event)),
          dataKey: "id",
          scrollHeight: "20rem",
          striped: "",
          pt: { root: '!flex-col-reverse', controls: '!flex-row' }
        }, {
          option: _withCtx(({ option }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "w-12 shrink-0 rounded",
                src: 'https://cdn.tiamutauto.com/' + option.img,
                alt: option.promotionName
              }, null, 8 /* PROPS */, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(option.promotionName), 1 /* TEXT */)
              ]),
              _createVNode(_component_ToggleSwitch, {
                modelValue: option.isPromotionActive,
                "onUpdate:modelValue": $event => ((option.isPromotionActive) = $event)
              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_Button, {
          label: "บันทึก",
          type: "submit",
          class: "w-full mt-5",
          loading: _ctx.form.btn.loading,
          disabled: _ctx.form.btn.disabled
        }, null, 8 /* PROPS */, ["loading", "disabled"])
      ], 32 /* NEED_HYDRATION */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}